import { Box, Typography, useTheme } from '@mui/material';
import { SentimentSatisfiedAlt, SentimentVeryDissatisfied } from '@mui/icons-material';
import React, { FC } from 'react';

interface Props {
  input: { type: string; comment: string };
}

const FeedbackComment: FC<Props> = ({ input }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: theme.palette.background.default,
        p: theme.spacing(2),
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {input.type === 'feedbackOnStrengths' ? (
          <SentimentSatisfiedAlt />
        ) : (
          <SentimentVeryDissatisfied />
        )}
        <Typography
          variant="subtitle1"
          sx={{ ml: theme.spacing(1), fontWeight: 700 }}
        >
          {input.type === 'feedbackOnStrengths' ? 'Stärken' : 'Verbesserungsmöglichkeiten'}
        </Typography>
      </Box>
      <Typography
        variant="body1"
        sx={{ mt: theme.spacing(1) }}
      >
        {input.comment}
      </Typography>
    </Box>
  );
};

export default FeedbackComment;
